import React, { useEffect, useState } from 'react';
import Tooltip from '../UI/Tooltip';
import './pricingtable.css';

function PricingTables() {
  return (
    <div>
      <table
        className="table panther-table table-edit sticky"
        style={{ margin: '10px auto 10px', textAlign: 'center' }}
      >
        <thead>
          <tr className="table-titles">
            <th></th>
            <th>FREE ACADEMIC</th>
            <th>STANDARD</th>
            <th>ADVANCED</th>
            <th>PREMIUM</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <th className="table-subtitles">Access Features</th>
            <th className="table-subtitles" colSpan="4"></th>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Web platform</a>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-gray"></i>
              <i className="position-absolute">*</i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">REST-API </a>
            </td>
            <td>
              {' '}
              <i className="bi bi-check-circle-fill check-gray"></i>
              <i className="position-absolute">*</i>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              {' '}
              <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
                <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                  R package
                </u>
              </a>
            </td>
            <td>
              {' '}
              <i className="bi bi-check-circle-fill check-gray"></i>
              <i className="position-absolute">*</i>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Offline access</a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              {' '}
              <a href="https://apps.cytoscape.org/apps/disgenetapp" target="_blank" rel="noopener noreferrer">
                <u className="table-subsubtitles" style={{ color: ' #52B7DB' }}>
                  Cytoscape App
                </u>
              </a>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-gray"></i>
              <i className="position-absolute">*</i>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">
                AI Assistant{' '}
                <Tooltip content="Ask questions about the data in plain text—no coding needed">
                  <i className="bi bi-info-circle"></i>
                </Tooltip>
              </a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              {/* <MyTooltip
                text="Bulk query up to 100 genes, diseases,
variants, or chemicals on the web"
              > */}

              <a className="table-subsubtitles ">
                Advanced Search{' '}
                <Tooltip
                  content="Bulk query up to 100 genes, diseases,
variants, or chemicals on the web"
                >
                  <i className="bi bi-info-circle"></i>
                </Tooltip>
              </a>

              {/* </MyTooltip> */}
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-gray"></i>
              <i className="position-absolute">*</i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <th className="table-subtitles">Data Features</th>
            <th className="table-subtitles" colSpan="4"></th>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Full database acess</a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">
                AI-mined Insights{' '}
                <Tooltip content="Extracted from scientific literature">
                  <i className="bi bi-info-circle"></i>
                </Tooltip>
              </a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Genes</a>
            </td>
            <td>13,600+</td>
            <td>29,400+</td>
            <td>29,400+</td>
            <td>29,400+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Variants</a>
            </td>
            <td>695,000+</td>
            <td>1.4M+</td>
            <td>1.4M+</td>
            <td>1.4M+</td>
          </tr>

          <tr>
            <td>
              <a className="table-subsubtitles">Diseases & Phenotypes</a>
            </td>
            <td>14,800+</td>
            <td>42,200+</td>
            <td>42,200+</td>
            <td>42,200+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Gene-Disease Associations (GDAs)</a>
            </td>
            <td>93,100+</td>
            <td>2M+</td>
            <td>2M+</td>
            <td>2M+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Variant-Disease Associations (VDAs)</a>
            </td>
            <td>1M+</td>
            <td>4.3M+</td>
            <td>4.3M+</td>
            <td>4.3M+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Disease-Disease Associations (DDAs)</a>
            </td>
            <td>110,000+</td>
            <td>28M+</td>
            <td>28M+</td>
            <td>28M+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Drugs & chemicals</a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>14,600+</td>
            <td>14,600+</td>
            <td>14,600+</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">
                Clinical Trial annotations{' '}
                <Tooltip content="Link findings to current research">
                  <i className="bi bi-info-circle"></i>
                </Tooltip>
              </a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">
                LoF/GoF annotations{' '}
                <Tooltip content="Highlight variants that disrupt or enhance gene function">
                  <i className="bi bi-info-circle"></i>
                </Tooltip>
              </a>
            </td>
            <td>
              <i className="bi bi-x-circle-fill x-circle"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
            <td>
              <i className="bi bi-check-circle-fill check-green"></i>
            </td>
          </tr>

          <tr>
            <td>
              <a className="table-subsubtitles">Data Update Frequency</a>
            </td>
            <td>Quarterly</td>
            <td>Quarterly</td>
            <td>Quarterly</td>
            <td>Quarterly</td>
          </tr>
          <tr>
            <td>
              <a className="table-subsubtitles">Data restrictions</a>
            </td>
            <td>*Curated data only</td>
            <td>Full data access</td>
            <td>Full data access</td>
            <td>Full data access</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default PricingTables;
